<template>
  <div class='p-3 vstack gap-3 bg-light'>
    <template v-if='resultOrchestrators.length > 0'>
      <div v-if="votingRoundReport.status == 'finished' && resultOrchestrators.length != 1" class='p-3 bg-white rounded shadow-sm'>
        <h3>{{ $t("backend.e2e.voting_round_reports.show.overall_turnout") }}</h3>
        <div class="accent-line mt-2 mb-4"></div>
        <TurnoutTable
          :turnout='votingRoundReport.turnout' />
      </div>
      <ResultOrchestrator
        v-for="resultOrchestrator in resultOrchestrators"
        :key="`result_orchestrator_${resultOrchestrator.id}`"
        :result-orchestrator="resultOrchestrator"
        :trustees="trustees"
        :voting-round-report="votingRoundReport"
        :contest="contestFor(resultOrchestrator.contestReference)"
        :threshold="orchestrator.threshold"
      />
    </template>
    <div v-else class="p-3 bg-white rounded shadow-sm">
      <template v-if='votingRoundReport.status == "starting"'>
        <h3>{{ $t("backend.e2e.voting_round_reports.show.ceremony_starting") }}</h3>
        <div class='accent-line mt-2 mb-4'></div>
      </template>
      <div class='text-center'>
        <AVSpinner size='md' style='width: 3rem; height: 3rem' color='dark' />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import type { ConferenceVotingRoundReport, ResultOrchestrator as IResultOrchestrator } from '@/types';
import { CeremonyChannelSubscription } from '@/channels/CeremonyChannel';
import ResultOrchestrator from '@/components/backend/ResultOrchestrator.vue';
import TurnoutTable from '@/components/backend/live/TurnoutTable.vue';

export default defineComponent({
  name: 'ResultCeremony',
  components: { TurnoutTable, ResultOrchestrator },
  props: {
    initData: Object,
    orchestratorId: {
      type: Number,
      required: true,
    },
    reportId: {
      type: Number,
      required: true,
    },
    refreshOnFinish: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      orchestrator: {} as IResultOrchestrator,
      resultOrchestrators: [],
      contests: [],
      votingRoundReport: {} as ConferenceVotingRoundReport,
      trustees: [],
    };
  },
  computed: {},
  methods: {
    handleReceived(data) {
      switch (data.type) {
        case 'full_update':
          this.contests = data.state.contests
          this.orchestrator = data.state.orchestrator;
          this.votingRoundReport = data.state.votingRoundReports.find((report) => report.id === this.reportId) ;
          this.resultOrchestrators = this.votingRoundReport.resultOrchestrators;
          this.trustees = data.state.trustees;
          break;
        default:
          this.subscription.fetchStatus('status');
      }
    },
    contestFor(contestReference) {
      return this.contests.find((c) => c.reference == contestReference)
    }
  },
  watch: {
    votingRoundReport(newVal, oldVal) {
      if (this.refreshOnFinish && newVal.status == "finished" && oldVal.status == "aggregating") {
        setTimeout(() => window.location.reload(), 500);
      }
    }
  },
  mounted() {
    if(this.initData) {
      this.orchestrator = this.initData.orchestrator;
      this.votingRoundReport = Array.isArray(this.initData.votingRoundReports) ? this.initData.votingRoundReports.find((report) => report.id === this.reportId) : this.initData.votingRoundReports
      this.resultOrchestrators = this.votingRoundReport.resultOrchestrators;
      this.trustees = this.initData.trustees;
      this.contests = this.initData.contests
    }

    this.subscription = new CeremonyChannelSubscription(this.orchestratorId, {
      received: this.handleReceived,
    }, this.votingRoundReport.id);
  },
  unmounted(){
    this.subscription?.unsubscribe();
  }
});
</script>
